import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=2a15cdde&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports